import { DialogTitle } from '@headlessui/react';
import { MapIcon } from '@heroicons/react/24/outline';
import { Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';
import SearchLocationInput from './SearchLocationInput';

function SearchLocation({ open, setOpen }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <MapIcon className="h-6 w-6 text-rcprimary-400" aria-hidden="true" />
        </div>
        <div className="mt-3 sm:mt-5">
          <DialogTitle
            as="h3"
            className="text-center font-semibold text-base text-black leading-6"
          >
            Update Your Location
          </DialogTitle>
          <div className="mt-2">
            <p className="text-center text-gray-500 text-sm">
              Find a Retainer Club partner near you.
            </p>
            <SearchLocationInput setOpen={setOpen} />
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-rcprimary-400 px-3 py-2 font-semibold text-black text-sm shadow-xs hover:bg-rcprimary-300 focus-visible:outline-2 focus-visible:outline-rcprimary-400 focus-visible:outline-solid focus-visible:outline-offset-2"
          onClick={() => setOpen(false)}
        >
          Go back
        </button>
      </div>
    </Modal>
  );
}

SearchLocation.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default SearchLocation;
